const getWidth = () => {
  let width;
  // check min width 992px
  if (window.innerWidth > 1200) {
    width = 1222;
  }
  // check min width 992px
  else if (window.innerWidth > 992) {
    width = 960;
  }

  // check min width 768px
  else if (window.innerWidth > 768) {
    width = 720;
  }

  // check min width 576px
  else if (window.innerWidth > 576) {
    width = 539;
  } else {
    width = false;
  }

  return width;
};

const getSwipeContainers = () => {
  return document.querySelectorAll(".swipe");
};

const setup = () => {
  // setup
  let width = getWidth();
  let swiperContainer = getSwipeContainers();

  // if width is less than or equal to 991px
  if (window.innerWidth <= 991 && swiperContainer.length > 0) {
      let rw = window.innerWidth - width;
      let rw2 = rw / 2;

      if(!width) {
        rw2 = 15;
      }


    // loop swiperContainer
    for (let i = 0; i < swiperContainer.length; i++) {
        // swiperContainer[i].style.width = width + "px";
        swiperContainer[i].style.paddingLeft = rw2 + "px";
    }
  }
  else {
    for (let i = 0; i < swiperContainer.length; i++) {
        swiperContainer[i].style.paddingLeft = "unset";
    }
  }
};

const swipe_cards = () => {
  // setup
  setup(); 
  window.addEventListener("resize", setup);
};

export default swipe_cards;
